import { FC } from 'react';
// component
import FormulasComponent from 'components/main/Formulas';

const Formulas: FC = () => <FormulasComponent />;

export default Formulas;
